import { getCurrencyFormatter } from '@/utils/currency/formatCurrency';

const currencySymbols: Record<string, string> = {};

export const getCurrencySymbol = (currencyCode: string): string => {
  if (currencyCode === '') {
    return currencyCode;
  }

  if (currencySymbols[currencyCode]) {
    return currencySymbols[currencyCode];
  }

  let currencySymbol = currencyCode;

  try {
    const formatter = getCurrencyFormatter(currencyCode);
    if (!formatter) {
      return currencySymbol;
    }

    const currencyPart = formatter.formatToParts().find((part) => part.type === 'currency');
    if (currencyPart) {
      currencySymbol = currencyPart.value;
    }
  } catch (error) {
    console.error(`Error retrieving currency symbol for ${currencyCode}:`, error);
  }

  currencySymbols[currencyCode] = currencySymbol;

  return currencySymbol;
};
